__turbopack_context__.v({
  "location": "LocalisationAndTime-module-scss-module__026bNG__location",
  "location-and-time": "LocalisationAndTime-module-scss-module__026bNG__location-and-time",
  "location-and-time--hiden-mobile": "LocalisationAndTime-module-scss-module__026bNG__location-and-time--hiden-mobile",
  "location-and-time__contact": "LocalisationAndTime-module-scss-module__026bNG__location-and-time__contact",
  "location-and-time__content": "LocalisationAndTime-module-scss-module__026bNG__location-and-time__content",
  "location-and-time__link": "LocalisationAndTime-module-scss-module__026bNG__location-and-time__link",
  "theme-selector": "LocalisationAndTime-module-scss-module__026bNG__theme-selector",
  "time": "LocalisationAndTime-module-scss-module__026bNG__time",
  "time__icon": "LocalisationAndTime-module-scss-module__026bNG__time__icon",
  "time__value": "LocalisationAndTime-module-scss-module__026bNG__time__value",
});
